import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row, Col } from 'antd';
import formatPrice from '~helpers/currency';
import { formatFullTime } from '~helpers';

export default class ChargeModal extends React.Component {
  render() {
    const { record, t } = this.props;
    if (!record || !record.charge) {
      return false;
    }

    return (
      <Modal
        visible={!!this.props.record}
        onCancel={() => {
          this.props.onCancel(null);
        }}
        footer={null}
        width={'880px'}
        zIndex={10000000}
        wrapClassName="charge-modal"
      >
        <div className="charge-modal__content">
          <h3 className="charge-modal__title">
            {t('landlord.long_tail.booking_details.charge_modal.title.charge_details')}
          </h3>
          <Row>
            <Col span={12}>
              <span className="charge-modal__field-name">
                {t('landlord.long_tail.booking_details.charge_modal.field.charge_number', {
                  referenceId: record.charge.referenceId,
                })}
              </span>
            </Col>
            <Col span={12}>
              <span className="charge-modal__field-name">
                {t('landlord.long_tail.booking_details.charge_modal.field.payment_method', {
                  method: t(
                    `landlord.long_tail.booking_details.charge_modal.payment_method.${record.charge.paymentMethod.toLowerCase()}`,
                  ),
                })}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <span className="charge-modal__field-name">
                {t('landlord.long_tail.booking_details.charge_modal.field.charge_amount', {
                  price: formatPrice(record.charge.chargeAmount, record.charge.chargeCurrency, 2),
                })}
              </span>
            </Col>
            <Col span={12}>
              <span className="charge-modal__field-name">
                {t('landlord.long_tail.booking_details.charge_modal.field.trade_number', {
                  tradeNo:
                    record.charge.paymentMethod === 'ALIPAY'
                      ? record.charge.tradeNo
                      : record.charge.stripeChargeId,
                })}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <span className="charge-modal__field-name">
                {t('landlord.long_tail.booking_details.charge_modal.field.paid_at', {
                  date: formatFullTime(record.paidAt),
                })}
              </span>
            </Col>
          </Row>
        </div>

        <div className="charge-modal__footer">
          <Button
            type="primary"
            size="large"
            onClick={() => {
              this.props.onCancel(null);
            }}
          >
            {t('landlord.long_tail.booking_details.transfer_modal.btn.close')}
          </Button>
        </div>
      </Modal>
    );
  }
}

ChargeModal.propTypes = {
  t: PropTypes.func,
  onCancel: PropTypes.func,
  record: PropTypes.object,
};

ChargeModal.defaultProps = {
  t: () => {},
  onCancel: () => {},
  record: null,
};
